module.exports = __webpack_public_path__ + "static/media/Bariatric-Behavioral Eating Patterns Questionnaire-1@3x.e663c377.png";